import React from 'react';

import { useRootState } from 'store/StateProvider';
import Input from 'components/forms/Input/Input';
import 'components/AssumptionsDrawer/assumptions-drawer.scss';

const DtcTable = () => {
    const { assumptions } = useRootState();
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Archive</th>
                    <th> </th>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
                {assumptions.dtc.data.map((row) => (
                    <tr key={row.credit}>
                        <td className="qa-label-container">{row.dtcCreditRate}</td>
                        <td>{row.empty}</td>
                        <td className="table-cell-editable qa-value-container">
                            <Input
                                type="number"
                                name={`dtc.${row.key}`}
                                isEditable={assumptions.isEditing}
                                defaultValue={assumptions.dtc.dtc}
                                className="qa-input-assumption-archive"
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default React.memo(DtcTable);
